import react, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "react-loader-spinner";

import { GetFlyerNotifications } from "../../Redux/Actions/notification";
import { clearSession } from "../../utils/initiate";
import { useTranslation } from "react-i18next";
import { getLocaleValue } from "../../utils";

function FlyerNotifications({ history }) {
  const dispatch = useDispatch();
  const userData = useSelector(({ User }) => User.data);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  useEffect(() => {
    let payload = {
      userId: userData?.UserId,
      statusType: "All",
    };
    setLoading(true);
    GetFlyerNotifications(payload)
      .then((res) => {
        if (res?.data) {
          setNotificationData(res.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        err?.response?.status === 401 && clearSession(dispatch, history);
      });
  }, []);

  return (
    <div>
      <div className="page-title-box" style={{ textAlign: "center" }}>
        <h4 className="page-title my-2">
          <label
            style={{
              borderBottom: "3px solid rgb(183, 28, 28)",
              fontSize: "25px",
              paddingBottom: "15px",
            }}
          >
            {getLocaleValue("home_drawer_flyerNotices")}
          </label>
        </h4>
      </div>
      <div
        // className="d-flex"
        style={{ justifyContent: "center", marginTop: "10px" }}
      >
        {loading ? (
          <Loader
            type="ThreeDots"
            color="#ad1a5f"
            height={40}
            width={40}
            style={{ textAlign: "center", marginBottom: "50px" }}
          />
        ) : notificationData.length ? (
          notificationData.map(({ title, message, documentURL }) => {
            return (
              <div
                className="col-8"
                style={{
                  marginTop: "10px",
                  border: "1px solid",
                  borderRadius: "5px",
                  padding: "10px",
                  margin: "10px auto",
                }}
              >
                <div>
                  {" "}
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <div>
                      <img
                        src={documentURL}
                        width="150px"
                        height="200px"
                        alt={title}
                      />
                    </div>
                    <div
                      className="col-6"
                      style={{ marginTop: "80px", marginLeft: "10px" }}
                    >
                      <div style={{ marginTop: 2, justifyContent: "center" }}>
                        <label style={{ fontWeight: "500", fontSize: "18px" }}>
                          {title}
                        </label>
                      </div>
                      <div style={{ marginTop: 2, justifyContent: "center" }}>
                        {message}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card"
            style={{ padding: "20px", marginRight: "10px" }}
          >
            <div style={{ justifyContent: "center", display: "flex" }}>
              {t("extra.no_data_available")}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FlyerNotifications;
